<template>
	<div class="app-wrapper" @click.right.prevent @copy.prevent>
		<router-view />
	</div>
</template>

<script>
	import { provide, watchEffect } from "vue";
	import store from "@/store";
	import masterStore from "@/store/masterStore";
	import packageEditState from "@/store/mastersState/packageEditStore";
	import leadState from "@/store/mastersState/leadState";
	import socket from "@/config/socket";
	import toast from "@/config/toast";
	import notifications from "@/store/notification";

	export default {
		name: "App",
		setup() {
			provide("store", store);
			provide("masterStore", masterStore);
			provide("packageEditState", packageEditState);
			provide("leadState", leadState);
			provide("socket", socket);
			provide("notifications", notifications);

			const setSocketListeners = () => {
				if (!store.state.auth.isAuth) return;
				socket.addEventListener("success", (data) => {
					if (store.state.auth.isAuth) {
						socket.emit("join", {
							role: store.state.user.role[0],
							id: store.state.user.id,
						});
					}
				});

				socket.addEventListener("joined", (data) => {
					console.log("-- Auth success: setting events --");
				});
				socket.addEventListener(`notification`, (data) => {
					notifications.methods.setNotification(data, "general");

					toast.success(data?.text);
				});

				socket.addEventListener(
					`notification_${store.state.user.role[0]}`,
					(data) => {
						notifications.methods.setNotification(data, "role");

						toast.success(data?.text);
					},
				);

				socket.addEventListener(
					`notification_${store.state.user.id}_success`,
					(data) => {
						notifications.methods.setNotification(data, "success");
						toast.success(data?.text);
					},
				);

				socket.addEventListener(
					`notification_${store.state.user.id}_warning`,
					(data) => {
						notifications.methods.setNotification(data, "warnings");
						toast.warning(data?.text);
					},
				);

				socket.addEventListener(
					`notification_${store.state.user.id}_error`,
					(data) => {
						notifications.methods.setNotification(data, "errors");

						toast.warning(data?.text);
					},
				);
			};
			
			watchEffect(() => setSocketListeners(store.state.auth.isAuth));
		},
	};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
	#app {
		min-height: 100vh;
		width: 100vw;
		margin: auto;
		margin-top: 70px;
		margin-bottom: 22px;
		padding: 1rem 2rem;
		overflow: auto;
		background: #fff;
		/* box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px, rgb(0 0 0 / 23%) 0px 3px 6px; */
		/* border-radius: 1rem; */
	}
</style>